import { useMemo } from 'react'

import { useRecoilValue } from 'recoil'

import type { ColumnName } from 'Pages/RecipientsList/model'

import { dynamicFieldsState } from 'Pages/RecipientsList/recoil/state/columns'

import { modalColumnsState } from 'Pages/RecipientsList/recoil/state/modals'

import { getColumnName } from 'Pages/RecipientsList/recoil/services/results'

const useColumnNameOptions = (
  index: number,
): Array<{
  label: string
  value: ColumnName
  disabled: boolean
}> => {
  const dynamicFields = useRecoilValue(dynamicFieldsState)

  const { items } = useRecoilValue(modalColumnsState)

  const options = useMemo(() => {
    const allColumnNames: ColumnName[] = [
      'Email',
      'Mobile',
      'EmailSubscriptionStatus',
      'SMSSubscriptionStatus',
      'Engagement',
      'Groups',
      'RegistrationDate',
      'EmailSubscriptionDate',
      'EmailPendingDate',
      'EmailUnsubscriptionDate',
      'ReasonEmail',
      'ConfirmedOptin',
      'SMSSubscriptionDate',
      'SMSUnsubscriptionDate',
      'ReasonSms',
      ...dynamicFields.map(({ id }) => `Field${id}` as ColumnName),
    ]

    const myColumn = items[index]

    const disabledColumns = allColumnNames.filter(
      (c) => c !== myColumn && items.includes(c),
    )

    const options = allColumnNames.map((c) => ({
      value: c,
      label: getColumnName(c, dynamicFields) as string,
      disabled: disabledColumns.includes(c),
    }))

    return options
  }, [dynamicFields, items, index])

  return options
}

export default useColumnNameOptions
